import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.522 7H7a1 1 0 1 1 0 2H3a2 2 0 0 1-2-2V3a1 1 0 1 1 2 0v2.675a11 11 0 0 1 19.96 5.38c.047.55-.412.997-.965.994-.552-.003-.996-.454-1.055-1.003A8.992 8.992 0 0 0 4.58 6.922 1.163 1.163 0 0 1 4.522 7ZM21 18.325a11 11 0 0 1-19.96-5.38c-.047-.55.412-.997.965-.994.552.003.996.454 1.055 1.003a8.992 8.992 0 0 0 16.36 4.124c.018-.027.038-.053.058-.078H17a1 1 0 1 1 0-2h4a2 2 0 0 1 2 2v4a1 1 0 1 1-2 0v-2.675Z",
      fill: "#0F0F0F"
    }, null, -1)
  ]))]))
}
export default { render };